import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueClick from 'vue-click'
import { loadFonts } from './plugins/webfontloader'
import './assets/style.scss'

loadFonts()

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(VueClick)
  .mount('#app')
